import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-manchester-form',
  templateUrl: './manchester-form.component.html',
  styleUrls: ['./manchester-form.component.scss']
})
export class ManchesterFormComponent {

  emailComponent= '@'
  fullName: string;
    email: any;
    date: any;
  firstName: any;
  lastName: any;
  dateOfBirth: any;
  whatsAppNo: any;
  courseName: any;
    constructor(
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<ManchesterFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
      ) { }
      ngOnInit(): void {
        console.log(this.data);
        if(this.data){
          this.fullName = `${this.data.firstName} ${this.data.lastName}`.toUpperCase();
          this.firstName = this.data.firstName;
          this.lastName = this.data.lastName;
          this.dateOfBirth = this.data.dateOfBirth;
          this.whatsAppNo = this.data.whatsAppNo;
          this.courseName = this.data.courseName;
          this.email = this.data.email;
          this.date = this.data.date;
        }
      }
      close(val?: any) {
        this.dialogRef.close(val);
      }
      sendForSignature() {
        this.dialogRef.close('sendForSignature');
    }
}

